<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left py-5>
        <span style="font-family: poppinssemibold; font-size: 22px">
          Add Cancellation Policy</span
        >
      </v-flex>
    </v-layout>
    <v-tabs v-model="tab" grow>
      <v-tabs-slider color="yellow"></v-tabs-slider>


      <v-tab v-for="(item, i) in policyData" :key="i">
        <span> {{ item.type }}</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, i) in policyData" :key="i">
        <v-card  flat class="pt-5">
         
          <v-layout wrap>
            <v-flex xs12 text-left> Heading </v-flex>
            <v-flex xs12 text-left>
              <v-text-field outlined v-model="item.heading"> </v-text-field>
            </v-flex>
            <v-flex xs12 text-left> content </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex>
                  <vue-editor
                    class="textField2 pt-1"
                    v-model="item.content"
                  ></vue-editor>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md6 py-6 pb-lg-10>
              <v-btn
                @click="addData(item)"
                dark
                tile
                width="100%"
                color="#FEBD08"
              >
                <!-- <span v-if="heading == null && content == null">add</span> -->
                <span> update</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      heading: null,
      content: null,
      appLoading: false,
      snackbar: false,
      msg: null,
      ServerError: false,
      tab: null,
      policyData: [],
      customer: {
        heading: null,
        content: null,
        type: "Customer",
      },
      seller: {
        heading: null,
        content: null,
        type: "Seller",
      },
      items: [
        {
          title: "SELLER",
          type: "Seller",
        },
        {
          title: "CUSTOMER",
          type: "Customer",
        },
      ],
        customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block"]
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    addData(data) {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/cancellationPolicy/add/update",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.getData();
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;

      axios({
        method: "get",
        url: "/cancellationPolicy/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // var tempData = [];
          if (response.data.status) {
            this.policyData = response.data.data;
            this.policyData=this.policyData.splice(0,2)
            // this.customer = this.policyData[0];
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>